import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { CLEAR_FORM, CLEAR_FORM_TEMPLATE, GET_FORM, GET_FORMS, GET_FORM_INSTANCE, GET_FORM_TEMPLATES_BY_TYPE, SUBMIT_FORM, CLEAR_FORM_ERROR } from 'actions/templates';
var INITIAL_STATE = {
  templates: null,
  formTemplate: null,
  form: null,
  forms: null,
  instance: null,
  templatesByType: {},
  submitting: false,
  submitSuccess: false,
  submitError: null
};
export default function () {
  var _action$payload, _action$payload2;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case CLEAR_FORM_TEMPLATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        formTemplate: INITIAL_STATE.formTemplate
      });
    case GET_FORM:
      return _objectSpread(_objectSpread({}, state), {}, {
        form: action.payload
      });
    case CLEAR_FORM:
      return _objectSpread(_objectSpread({}, state), {}, {
        form: INITIAL_STATE.form,
        formTemplate: INITIAL_STATE.formTemplate
      });
    case GET_FORMS:
      return _objectSpread(_objectSpread({}, state), {}, {
        forms: action.payload
      });
    case GET_FORM_INSTANCE:
      return _objectSpread(_objectSpread({}, state), {}, {
        instance: action.payload
      });
    case GET_FORM_TEMPLATES_BY_TYPE:
      return _objectSpread(_objectSpread({}, state), {}, {
        templatesByType: _objectSpread(_objectSpread({}, state.templatesByType), {}, _defineProperty({}, action.payload.type, action.payload.data))
      });
    case SUBMIT_FORM:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitting: true,
        submitSuccess: false,
        submitError: null
      });
    case "".concat(SUBMIT_FORM, "_FULFILLED"):
      return _objectSpread(_objectSpread({}, state), {}, {
        submitting: false,
        submitSuccess: true,
        submitError: null,
        form: action.payload
      });
    case "".concat(SUBMIT_FORM, "_REJECTED"):
      return _objectSpread(_objectSpread({}, state), {}, {
        submitting: false,
        submitSuccess: false,
        submitError: ((_action$payload = action.payload) === null || _action$payload === void 0 || (_action$payload = _action$payload.response) === null || _action$payload === void 0 || (_action$payload = _action$payload.data) === null || _action$payload === void 0 ? void 0 : _action$payload.message) || ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.message) || 'Failed to submit form'
      });
    case CLEAR_FORM_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        submitError: null,
        submitSuccess: false
      });
    default:
      return state;
  }
}